var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4707 1.01172H23.053V7.24464H7.4707V1.01172Z",
    fill: "#DFF0FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5335 1.53101V6.72511H7.98999V1.53101H22.5335ZM23.5723 0.492188H6.95117V7.76393H23.5723V0.492188Z",
    fill: "#4788C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23828 4.12793H29.2864V39.4478H1.23828V4.12793Z",
    fill: "#DFF0FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7669 4.64819V38.9292H1.75757V4.64819H28.7669ZM29.8057 3.60938H0.71875V39.9681H29.8057V3.60938Z",
    fill: "#4788C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.665 33.2148H17.8591V39.4478H12.665V33.2148Z",
    fill: "#98CBFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3406 33.7341V38.9282H13.1853V33.7341H17.3406ZM18.3794 32.6953H12.1465V39.9671H18.3794V32.6953Z",
    fill: "#98CBFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1465 26.4615H18.3794V29.5779H12.1465V26.4615ZM12.1465 20.2285H18.3794V23.345H12.1465V20.2285ZM12.1465 13.9956H18.3794V17.1121H12.1465V13.9956ZM12.1465 7.7627H18.3794V10.8792H12.1465V7.7627ZM20.4571 26.4615H26.69V29.5779H20.4571V26.4615ZM20.4571 20.2285H26.69V23.345H20.4571V20.2285ZM20.4571 13.9956H26.69V17.1121H20.4571V13.9956ZM20.4571 7.7627H26.69V10.8792H20.4571V7.7627ZM3.83594 26.4615H10.0689V29.5779H3.83594V26.4615ZM20.4571 32.6944H26.69V35.8108H20.4571V32.6944ZM3.83594 32.6944H10.0689V35.8108H3.83594V32.6944Z",
    fill: "#98CBFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83594 20.2305H10.0689V23.3469H3.83594V20.2305Z",
    fill: "#98CBFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83594 13.9971H10.0689V17.1135H3.83594V13.9971Z",
    fill: "#98CBFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83594 7.76367H10.0689V10.8801H3.83594V7.76367Z",
    fill: "#98CBFD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc2);
export default __webpack_public_path__ + "static/media/pc2.963287bc09ed80aca63df89fc80124c0.svg";
export { ForwardRef as ReactComponent };